/* GM Vegasi – scheda prodotto: la taglia va scelta esplicitamente.
   Prima: Dawn preselezionava la prima taglia disponibile e "Aggiungi al carrello"
   aggiungeva quella taglia anche se il cliente non l'aveva scelta.
   Ora: nessuna taglia appare selezionata finche' il cliente non tocca una pill;
   se prova ad aggiungere al carrello senza sceglierla, compare un messaggio accanto
   alle taglie e il focus si sposta sulla prima taglia disponibile.
   Non tocca varianti, prezzi o la logica di Dawn: lavora solo su classi e sul submit. */
(function () {
  'use strict';
  // gmv-style puo' essere renderizzato piu' volte: un'unica istanza condivide lo stato
  if (window.__gmvCroSize) return;
  window.__gmvCroSize = true;
  var SIZE_NAMES = /^(taglia|taglie|misura|size|numero)\b/i;
  var chosen = false;

  function sizeFieldset(root) {
    var sets = root.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && SIZE_NAMES.test(lg.textContent.trim())) return sets[i];
    }
    return null;
  }

  function availableInputs(fs) {
    return Array.prototype.filter.call(fs.querySelectorAll('input[type="radio"]'), function (i) {
      return !i.classList.contains('disabled') && !i.disabled;
    });
  }

  function errorNode(fs) {
    var el = fs.parentNode.querySelector('.gmv-size-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'gmv-size-error';
      el.id = 'gmv-size-error-' + Math.random().toString(36).slice(2, 8);
      el.setAttribute('role', 'alert');
      el.hidden = true;
      el.textContent = 'Seleziona la tua taglia per aggiungere il prodotto al carrello.';
      fs.insertAdjacentElement('afterend', el);
    }
    return el;
  }

  function needsChoice(fs) {
    return fs && availableInputs(fs).length > 1;
  }

  function apply(root) {
    var fs = sizeFieldset(root);
    if (!fs) return;
    fs.classList.add('gmv-size-fs');
    if (!needsChoice(fs)) { chosen = true; }
    fs.classList.toggle('gmv-size-pending', !chosen);
    if (!fs.dataset.gmvBound) {
      fs.dataset.gmvBound = '1';
      // click (non change): anche toccare la taglia gia' preselezionata vale come scelta
      fs.addEventListener('click', function (e) {
        var input = e.target.closest('input[type="radio"]') ||
          (e.target.closest('label') && document.getElementById(e.target.closest('label').htmlFor));
        if (!input || input.classList.contains('disabled')) return;
        chosen = true;
        fs.classList.remove('gmv-size-pending', 'gmv-size-invalid');
        var err = fs.parentNode.querySelector('.gmv-size-error');
        if (err) err.hidden = true;
      });
    }
  }

  function blockIfPending(e, root) {
    if (chosen) return;
    var fs = sizeFieldset(root);
    if (!needsChoice(fs)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fs.classList.add('gmv-size-invalid');
    var err = errorNode(fs);
    err.hidden = false;
    fs.setAttribute('aria-describedby', err.id);
    var first = availableInputs(fs)[0];
    fs.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    if (first) first.focus({ preventScroll: true });
  }

  function init() {
    // Solo il prodotto principale (non quick-add/featured product in altre sezioni)
    var root = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
    if (!root) return;
    apply(root);
    // Dawn ri-renderizza il blocco varianti a ogni cambio colore: riapplica lo stato.
    new MutationObserver(function () { apply(root); }).observe(root, { childList: true, subtree: true });
    // Fase di cattura: interviene prima del submit AJAX di product-form.js
    document.addEventListener('submit', function (e) {
      if (root.contains(e.target) && e.target.matches('form[action*="/cart/add"]')) blockIfPending(e, root);
    }, true);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="add"], .product-form__submit');
      if (btn && root.contains(btn)) blockIfPending(e, root);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
